module.exports = __webpack_public_path__ + "a2314fc9/img/comments-icon.334fbbd6.svg";